import React from 'react'
import './sticky-banner.css'

const StickyBanner = props => {

    const {stickyInfo, backgroundColor} = props;

    return (
        <div
            className={`mcb__stickyContainer ${backgroundColor === 'blue' ? 'blueBackground' : ''}`}>
            {stickyInfo.map((info, index) => (
                <div className="propTile" key={index}>
                    <div className="propKey">
                        {info.name}
                    </div>
                    <div className="propVal">
                        {info.value}
                    </div>
                </div>
            ))}
        </div>
    )
}
export default StickyBanner
